/** 登录返回 user.powerList 中「危化业务查询」权限名称 */
export const HAZARDOUS_BUSINESS_POWER_NAME = '危化业务查询'

const LOGIN_POWER_LIST_KEY = 'login_user_power_list'

function normalizePowerList(user) {
  if (!user || typeof user !== 'object') return []
  const raw = user.powerList != null ? user.powerList : user.powers
  return Array.isArray(raw) ? raw : []
}

/** 登录成功后缓存权限列表 */
export function saveLoginUserPowers(user) {
  const list = normalizePowerList(user)
  try {
    localStorage.setItem(LOGIN_POWER_LIST_KEY, JSON.stringify(list))
  } catch (e) {
    localStorage.removeItem(LOGIN_POWER_LIST_KEY)
  }
}

export function clearLoginUserPowers() {
  localStorage.removeItem(LOGIN_POWER_LIST_KEY)
}

export function getLoginUserPowerList() {
  try {
    const raw = localStorage.getItem(LOGIN_POWER_LIST_KEY)
    if (!raw) return []
    const parsed = JSON.parse(raw)
    return Array.isArray(parsed) ? parsed : []
  } catch (e) {
    return []
  }
}

/** 是否拥有「危化业务查询」权限（控制危化管理菜单） */
export function hasHazardousBusinessPower() {
  const list = getLoginUserPowerList()
  return list.some((item) => {
    const name =
      item && item.powerName != null ? String(item.powerName).trim() : ''
    return name === HAZARDOUS_BUSINESS_POWER_NAME
  })
}
